export const FORMATO_FECHAS = {
  YYYY_MM_DD_GUIONES: 'YYYY-MM-DD',
  DD_MM_YYY_SLASH: 'DD/MM/YYYY',
}
